export default __webpack_public_path__ + "static/Prototyp_IMG_1092-scaled-f725e25a13d1dd07761d0e6458d011fb.jpg";